import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RecordUsageDto, UsageResultVm, UsageSummaryVm } from '../models';

@Injectable({ providedIn: 'root' })
export class UsageService {
  private http = inject(HttpClient);
  private base(tenantId: string) { return `${environment.apiBaseUrl}/tenants/${tenantId}/usage`; }

  record(tenantId: string, dto: RecordUsageDto): Observable<UsageResultVm> {
    return this.http.post<UsageResultVm>(`${this.base(tenantId)}/record`, dto);
  }

  getSummary(tenantId: string, billingPeriod?: string): Observable<UsageSummaryVm> {
    let hp = new HttpParams();
    if (billingPeriod) hp = hp.set('billingPeriod', billingPeriod);
    return this.http.get<UsageSummaryVm>(`${this.base(tenantId)}/summary`, { params: hp });
  }
}
